module.exports = __webpack_public_path__ + "img/gold.68fac8df.gif";